import { render } from "./main.html?vue&type=template&id=2a242e06"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"
script.render = render

export default script